        (function() {
            const seen = new Set();
            function report(message, detail) {
                const key = (message || '') + '|' + (detail || '').slice(0, 200);
                if (seen.has(key)) return;
                seen.add(key);
                try {
                    fetch('/api/log-error', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch' },
                        body: JSON.stringify({ message: String(message || 'Unknown error').slice(0, 500), detail: detail || '', pageUrl: location.pathname })
                    }).catch(() => {});
                } catch (err) { /* reporting a bug must never itself throw */ }
            }
            window.addEventListener('error', (e) => {
                report(e.message, e.error && e.error.stack ? e.error.stack : `${e.filename}:${e.lineno}:${e.colno}`);
            });
            window.addEventListener('unhandledrejection', (e) => {
                const reason = e.reason;
                report(reason && reason.message ? reason.message : String(reason), reason && reason.stack ? reason.stack : '');
            });
        })();
